export default {
    'nav.home': 'HOME',
    'nav.game': 'GAMES',
    'nav.about': 'ABOUT',
    'nav.career': 'CAREER',
    'nav.contact': 'CONTACT'
};
